import React from 'react';
import { IntegrationControllerBaseConfig } from '../../../base';
import { ThreadNewController } from './integrationNewInterface';
import { ThreadNewViewProps } from './integrationNewProps';
import { FiPhone, FiMoreHorizontal } from 'react-icons/fi';
import { useDisclosure } from '@chakra-ui/react';
import { MdOutlineHeadphones } from 'react-icons/md';

export function createThreadNewController(
    config: IntegrationControllerBaseConfig
): ThreadNewController {
    const {
        controller: {
            thread: { detail: threadController },
        },
    } = config;
    return {
        useProps(context, data, props): ThreadNewViewProps {
            const handleCall = React.useCallback(() => {
                console.log('Starting call for integration:', data.integration?.id);
            }, [data.integration?.id]);

            return {
                common: {
                    more: {
                        isOpen: false,
                        onOpen: () => {},
                        onClose: () => {},
                        items: [
                            {
                                id: 'view-integration',
                                label: 'View Integration',
                                onClick: () => {
                                    // TODO: Navigate to integration details
                                },
                            },
                        ],
                    },
                    header: {
                        person: {
                            name: data.definition.display_name || 'Agent',
                            avatar: '', // TODO: Get avatar from integration definition
                            isOnline: data.integration?.status === 'active',
                        },
                        tabs: {
                            active: 'messages',
                            onChange: () => {},
                        },
                    },
                    hero: {
                        title: `This conversation is just between @${data.definition.display_name || 'Agent'} and you.`,
                        description: `Check out their profile to learn more about them.`,
                        actions: [
                            {
                                id: 'view-profile',
                                label: 'View Profile',
                                onClick: () => console.log('View Profile clicked'),
                                variant: 'secondary' as const,
                            },
                        ],
                    },
                    thread: {
                        // TODO make the thread controller work without pre-existing thread model
                        messages: {
                            sections: [],
                            container: {
                                ref: React.createRef(),
                                onScroll: () => {},
                                isScrolling: false,
                            },
                        },
                        typing: {
                            isVisible: false,
                            authorName: '',
                        },
                        call: {
                            button: {
                                onClick: handleCall,
                                onFocus: () => {},
                            },
                            tooltip: {
                                label: 'Start call',
                                openDelay: 300,
                            },
                            label: 'Start call',
                            Icon: MdOutlineHeadphones,
                        },
                        composer: props.composer,
                    },
                    call: null,
                },
            };
        },
    };
}
